export const TABS = {
  THEMES: 'Themes',
  SAVED_TEMPLATES: 'Saved Templates',
};

export const ebayAllCategories = {
  'Antiques': [
    'Antiquities',
    'Architectural & Garden',
    'Asian Antiques',
    'Decorative Arts',
    'Ethnographic',
    'Furniture',
    'Home & Hearth',
    'Incunabula',
    'Linens & Textiles (Pre-1930)',
    'Manuscripts',
    'Maps, Atlases & Globes',
    'Maritime',
    'Mercantile, Trades & Factories',
    'Musical Instruments (Pre-1930)',
    'Other Antiques',
    'Periods & Styles',
    'Primitives',
    'Reproduction Antiques',
    'Restoration & Care',
    'Science & Medicine (Pre-1930)',
    'Sewing (Pre-1930)',
    'Silver',
  ],
  'Art': [
    'Art from Dealers & Resellers',
    'Direct from the Artist',
  ],
  'Baby': [
    'Baby Gear',
    'Baby Safety & Health',
    'Bathing & Grooming',
    'Car Safety Seats',
    'Carriers, Slings & Backpacks',
    'Diapering',
    'Feeding',
    'Keepsakes & Baby Announcements',
    'Nursery Bedding',
    'Nursery Décor',
    'Nursery Furniture',
    'Other Baby',
    'Potty Training',
    'Strollers & Accessories',
    'Toys for Baby',
  ],
  'Books': [
    'Accessories',
    'Antiquarian & Collectible',
    'Audiobooks',
    'Catalogs',
    'Children & Young Adults',
    'Cookbooks',
    'Fiction & Literature',
    'Magazine Back Issues',
    'Nonfiction',
    'Other Books',
    'Textbooks, Education',
    'Wholesale & Bulk Lots',
  ],
  'Business & Industrial': [
    'Agriculture & Forestry',
    'Automation, Motors & Drives',
    'Construction',
    'Electrical & Test Equipment',
    'Fuel & Energy',
    'Healthcare, Lab & Life Science',
    'Heavy Equipment',
    'Heavy Equipment Attachments',
    'Heavy Equipment Parts & Accs',
    'Light Equipment & Tools',
    'Manufacturing & Metalworking',
    'MRO & Industrial Supply',
    'Office',
    'Other Business & Industrial',
    'Packing & Shipping',
    'Printing & Graphic Arts',
    'Restaurant & Catering',
    'Retail & Services',
    'Websites & Businesses for Sale',
  ],
  'Cameras & Photo': [
    'Binoculars & Telescopes',
    'Camcorders',
    'Camera & Photo Accessories',
    'Camera Drone Parts & Accs',
    'Camera Drones',
    'Camera Manuals & Guides',
    'Digital Cameras',
    'Digital Photo Frames',
    'Film Photography',
    'Flashes & Flash Accessories',
    'Lenses & Filters',
    'Lighting & Studio',
    'Other Cameras & Photo',
    'Replacement Parts & Tools',
    'Tripods & Supports',
    'Video Production & Editing',
    'Vintage Movie & Photography',
  ],
  'Cell Phones & Accessories': [
    'Cell Phone & Smartphone Parts',
    'Cell Phone Accessories',
    'Cell Phones & Smartphones',
    'Display Phones',
    'Other Cell Phones & Accs',
    'Phone Cards & SIM Cards',
    'Smart Watch Accessories',
    'Smart Watches',
    'Vintage Cell Phones',
  ],
  'Clothing, Shoes & Accessories': [
    'Baby & Toddler Clothing',
    'Costumes, Reenactment, Theater',
    'Cultural & Ethnic Clothing',
    'Dancewear',
    'Kids\' Clothing, Shoes & Accs',
    'Men\'s Accessories',
    'Men\'s Clothing',
    'Men\'s Shoes',
    'Uniforms & Work Clothing',
    'Unisex Clothing, Shoes & Accs',
    'Vintage',
    'Wedding & Formal Occasion',
    'Wholesale, Large & Small Lots',
    'Women\'s Accessories',
    'Women\'s Clothing',
    'Women\'s Handbags & Bags',
    'Women\'s Shoes',
  ],
  'Coins & Paper Money': [
    'Bullion',
    'Coins: Ancient',
    'Coins: Canada',
    'Coins: Medieval',
    'Coins: US',
    'Coins: World',
    'Exonumia',
    'Other Coins & Paper Money',
    'Paper Money: US',
    'Paper Money: World',
    'Publications & Supplies',
    'Stocks & Bonds, Scripophily',
    'Virtual Currency',
  ],
  'Collectibles': [
    'Advertising',
    'Animals',
    'Animation Art & Characters',
    'Arcade, Jukeboxes & Pinball',
    'Autographs',
    'Banks, Registers & Vending',
    'Barware',
    'Beads',
    'Bottles & Insulators',
    'Breweriana, Beer',
    'Casino',
    'Clocks',
    'Comics',
    'Credit, Charge Cards',
    'Cultures & Ethnicities',
    'Decorative Collectibles',
    'Disneyana',
    'Fantasy, Mythical & Magic',
    'Historical Memorabilia',
    'Holiday & Seasonal',
    'Kitchen & Home',
    'Knives, Swords & Blades',
    'Lamps, Lighting',
    'Linens & Textiles (1930-Now)',
    'Metalware',
    'Militaria',
    'Non-Sport Trading Cards',
    'Paper',
    'Pens & Writing Instruments',
    'Pez, Keychains, Promo Glasses',
    'Phone Cards',
    'Photographic Images',
    'Pinbacks, Bobbles, Lunchboxes',
    'Postcards',
    'Radio, Phonograph, TV, Phone',
    'Religion & Spirituality',
    'Rocks, Fossils & Minerals',
    'Science & Medicine (1930-Now)',
    'Science Fiction & Horror',
    'Sewing (1930-Now)',
    'Souvenirs & Travel Memorabilia',
    'Tobacciana',
    'Tools, Hardware & Locks',
    'Transportation',
    'Vanity, Perfume & Shaving',
    'Vintage, Retro, Mid-Century',
  ],
  'Computers/Tablets & Networking': [
    '3D Printers & Supplies',
    'Computer Cables & Connectors',
    'Computer Components & Parts',
    'Desktops & All-In-Ones',
    'Drives, Storage & Blank Media',
    'Enterprise Networking, Servers',
    'Home Networking & Connectivity',
    'Keyboards, Mice & Pointers',
    'Laptop & Desktop Accessories',
    'Laptops & Netbooks',
    'Manuals & Resources',
    'Monitors, Projectors & Accs',
    'Other Computers & Networking',
    'Power Protection, Distribution',
    'Printers, Scanners & Supplies',
    'Software',
    'Tablet & eBook Reader Accs',
    'Tablet & eBook Reader Parts',
    'Tablets & eBook Readers',
    'Vintage Computing',
  ],
  'Consumer Electronics': [
    'Gadgets & Other Electronics',
    'Home Automation',
    'Home Surveillance',
    'Home Telephones & Accessories',
    'Multipurpose Batteries & Power',
    'Portable Audio & Headphones',
    'Radio Communication',
    'TV, Video & Home Audio',
    'Vehicle Electronics & GPS',
    'Vintage Electronics',
    'Virtual Reality',
    'Wholesale Lots',
  ],
  'Crafts': [
    'Art Supplies',
    'Beads & Jewelry Making',
    'Fabric',
    'Fabric Painting & Decorating',
    'Glass & Mosaics',
    'Handcrafted & Finished Pieces',
    'Home Arts & Crafts',
    'Kids\' Crafts',
    'Leathercrafts',
    'Multi-Purpose Craft Supplies',
    'Needlecrafts & Yarn',
    'Other Crafts',
    'Scrapbooking & Paper Crafts',
    'Sculpting, Molding & Ceramics',
    'Sewing',
    'Stamping & Embossing',
  ],
  'Dolls & Bears': [
    'Bear Making Supplies',
    'Bears',
    'Dollhouse Miniatures',
    'Dolls',
    'Paper Dolls',
  ],
  'DVDs & Movies': [
    'DVDs & Blu-ray Discs',
    'Film Stock',
    'Laserdiscs',
    'Storage & Media Accessories',
    'UMDs',
    'VHS Tapes',
  ],
  'eBay Motors': [
    'Boats',
    'Cars & Trucks',
    'Motorcycles',
    'Other Vehicles & Trailers',
    'Parts & Accessories',
    'Powersports',
  ],
  'Entertainment Memorabilia': [
    'Autographs-Original',
    'Movie Memorabilia',
    'Music Memorabilia',
    'Other Entertainment Mem',
    'Television Memorabilia',
    'Theater Memorabilia',
    'Video Game Memorabilia',
  ],
  'Gift Cards & Coupons': [
    'Coupons',
    'Digital Gifts',
    'eBay Gift Cards',
    'Gift Cards',
    'Gift Certificates',
  ],
  'Health & Beauty': [
    'Bath & Body',
    'Fragrances',
    'Hair Care & Styling',
    'Health Care',
    'Makeup',
    'Massage',
    'Medical, Mobility & Disability',
    'Nail Care, Manicure & Pedicure',
    'Natural & Alternative Remedies',
    'Oral Care',
    'Other Health & Beauty',
    'Salon & Spa Equipment',
    'Shaving & Hair Removal',
    'Skin Care',
    'Sun Protection & Tanning',
    'Tattoos & Body Art',
    'Vision Care',
    'Vitamins & Dietary Supplements',
  ],
  'Home & Garden': [
    'Bath',
    'Bedding',
    'Food & Beverages',
    'Fresh Cut Flowers & Supplies',
    'Greeting Cards & Party Supply',
    'Holiday & Seasonal Décor',
    'Home Décor',
    'Home Improvement',
    'Household Supplies & Cleaning',
    'Kids & Teens at Home',
    'Kitchen, Dining & Bar',
    'Lamps, Lighting & Ceiling Fans',
    'Major Appliances',
    'Other Home & Garden',
    'Rugs & Carpets',
    'Tools',
    'Wedding Supplies',
    'Window Treatments & Hardware',
    'Yard, Garden & Outdoor Living',
  ],
  'Jewelry & Watches': [
    'Children\'s Jewelry',
    'Engagement & Wedding',
    'Ethnic, Regional & Tribal',
    'Fashion Jewelry',
    'Fine Jewelry',
    'Handcrafted, Artisan Jewelry',
    'Jewelry Boxes & Organizers',
    'Jewelry Design & Repair',
    'Loose Beads',
    'Loose Diamonds & Gemstones',
    'Men\'s Jewelry',
    'Other Jewelry & Watches',
    'Vintage & Antique Jewelry',
    'Watches, Parts & Accessories',
  ],
  'Music': [
    'Cassettes',
    'CDs',
    'Other Formats',
    'Records',
  ],
  'Musical Instruments & Gear': [
    'Brass',
    'DJ Equipment',
    'Equipment',
    'Guitars & Basses',
    'Instruction Books, CDs & Video',
    'Karaoke Entertainment',
    'Other Musical Instruments',
    'Percussion',
    'Pianos, Keyboards & Organs',
    'Pro Audio Equipment',
    'Sheet Music & Song Books',
    'Stage Lighting & Effects',
    'String',
    'Vintage Musical Instruments',
    'Wind & Woodwind',
  ],
  'Pet Supplies': [
    'Backyard Poultry Supplies',
    'Bird Supplies',
    'Cat Supplies',
    'Dog Supplies',
    'Fish & Aquariums',
    'Other Pet Supplies',
    'Pet Memorials & Urns',
    'Reptile Supplies',
    'Small Animal Supplies',
  ],
  'Pottery & Glass': [
    'Glass',
    'Pottery & China',
  ],
  'Real Estate': [
    'Commercial',
    'Land',
    'Manufactured Homes',
    'Other Real Estate',
    'Residential',
    'Timeshares for Sale',
  ],
  'Specialty Services': [
    'Artistic Services',
    'Custom Clothing & Jewelry',
    'eBay Auction Services',
    'Graphic & Logo Design',
    'Home Improvement Services',
    'Item Based Services',
    'Media Editing & Duplication',
    'Other Specialty Services',
    'Printing & Personalization',
    'Restoration & Repair',
    'Web & Computer Services',
  ],
  'Sporting Goods': [
    'Boxing, Martial Arts & MMA',
    'Cycling',
    'Fishing',
    'Fitness, Running & Yoga',
    'Golf',
    'Hunting',
    'Indoor Games',
    'Other Sporting Goods',
    'Outdoor Sports',
    'Team Sports',
    'Tennis & Racquet Sports',
    'Water Sports',
    'Winter Sports',
  ],
  'Sports Mem, Cards & Fan Shop': [
    'Autographs-Reprints',
    'Fan Apparel & Souvenirs',
    'Game Used Memorabilia',
    'Sports Stickers, Sets & Albums',
    'Sports Trading Cards',
    'Vintage Sports Memorabilia',
  ],
  'Stamps': [
    'Africa',
    'Asia',
    'Australia & Oceania',
    'British Colonies & Territories',
    'Canada',
    'Caribbean',
    'Europe',
    'Great Britain',
    'Latin America',
    'Middle East',
    'Other Stamps',
    'Specialty Philately',
    'Topical Stamps',
    'United States',
    'Worldwide',
  ],
  'Tickets & Experiences': [
    'Concert Tickets',
    'Other Tickets & Experiences',
    'Parking Passes',
    'Special Experiences',
    'Sports Tickets',
    'Theater Tickets',
    'Theme Park & Club Passes',
  ],
  'Toys & Hobbies': [
    'Action Figures',
    'Beanbag Plush',
    'Building Toys',
    'Classic Toys',
    'Collectible Card Games',
    'Diecast & Toy Vehicles',
    'Educational',
    'Electronic, Battery & Wind-Up',
    'Fast Food & Cereal Premiums',
    'Games',
    'Marbles',
    'Model Railroads & Trains',
    'Models & Kits',
    'Outdoor Toys & Structures',
    'Preschool Toys & Pretend Play',
    'Puzzles',
    'Radio Control & Control Line',
    'Robots, Monsters & Space Toys',
    'Slot Cars',
    'Stuffed Animals',
    'Toy Soldiers',
    'TV, Movie & Character Toys',
    'Vintage & Antique Toys',
  ],
  'Travel': [
    'Airline',
    'Campground & RV Parks',
    'Car Rental',
    'Cruises',
    'Lodging',
    'Luggage',
    'Luggage Accessories',
    'Maps',
    'Other Travel',
    'Rail',
    'Travel Accessories',
    'Vacation Packages',
    'Vintage Luggage & Travel Accs',
  ],
  'Video Games & Consoles': [
    'Manuals, Inserts & Box Art',
    'Original Game Cases & Boxes',
    'Other Video Games & Consoles',
    'Prepaid Gaming Cards',
    'Strategy Guides & Cheats',
    'Video Game Accessories',
    'Video Game Consoles',
    'Video Game Merchandise',
    'Video Games',
  ],
  'Everything Else': [
    'Adult Only',
    'Career Development & Education',
    'eBay Special Offers',
    'eBay User Tools',
    'Every Other Thing',
    'Funeral & Cemetery',
    'Genealogy',
    'Information Products',
    'Metaphysical',
    'New Created Parent 1',
    'Personal Development',
    'Personal Security',
    'Religious Products & Supplies',
    'Reward Points & Incentives',
    'Test Auctions',
    'Weird Stuff',
  ]
};
